export default "__VITE_ASSET__8663fa80__"